module.exports = __webpack_public_path__ + "img/delete.f1f79ef3.svg";